import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  snapDefaultBank,
  unSnapDefaultBank,
} from "store/bailiff/default/bank/default_bank.action";
import {
  snapDefaultWallet,
  unSnapDefaultWallet,
} from "store/bailiff/default/wallet/default_wallet.action";
import {
  snapSettingWithdraw,
  unSnapSettingWithdraw,
} from "store/bailiff/default/withdraw/setting_withdraw.action";

import { getFinanceSupporterByDate } from "store/bailiff/finance/supporter/finance_supporter.action";
import { financeSupporterDatesSelector } from "store/bailiff/finance/supporter/finance_supporter.selector";
import {
  fetchBanksList,
  getPaymentWithdrawByDates,
  snapLastWithdraw,
  unSnapLastWithdraw,
} from "store/bailiff/payment/withdraw/payment_withdraw.action";
import { getTotalTask } from "store/bailiff/task/task_count/task_count.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const dates = useSelector(financeSupporterDatesSelector);

  // -------------------------- USE EFFECT ---------------------

  // get finance
  useEffect(() => {
    if (dates && dates?.length > 0) {
      const from = dates?.[0]?.startOf("days");
      const to = dates?.[1]?.endOf("days");
      dispatch(getFinanceSupporterByDate({ from, to }));
    }
  }, [dates, dispatch]);

  //get withdraw
  useEffect(() => {
    if (dates && dates?.length > 0) {
      const from = dates?.[0]?.startOf("days");
      const to = dates?.[1]?.endOf("days");
      dispatch(getPaymentWithdrawByDates({ from, to }));
    }
  }, [dates, dispatch]);

  // snap my banks account
  useEffect(() => {
    dispatch(snapDefaultBank());
    return () => dispatch(unSnapDefaultBank());
  }, [dispatch]);

  // snap setting
  useEffect(() => {
    dispatch(snapSettingWithdraw());
    return () => dispatch(unSnapSettingWithdraw());
  }, [dispatch]);

  // snap wallet
  useEffect(() => {
    dispatch(snapDefaultWallet());
    return () => dispatch(unSnapDefaultWallet());
  }, [dispatch]);

  // snap last withdraw
  useEffect(() => {
    dispatch(snapLastWithdraw());
    return () => dispatch(unSnapLastWithdraw());
  }, [dispatch]);

  // GET BANK LISTS
  useEffect(() => {
    dispatch(fetchBanksList());
  }, [dispatch]);

  //total tasks
  useEffect(() => {
    dispatch(getTotalTask());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
